// segmentWallpaper — pure helpers for per-Segment background (wallpaper) mode.

/**
 * Decide the per-Segment background mode (`current_bg`) after an
 * "add / remove background wallpaper" action.
 *
 * `current_bg` legend: 0 = solid colour / none · 1 = pattern · 2 = image.
 *
 * Bug F6.8: the "Remove image" control calls
 * `handleChange("addBgWallpaper", 0, "")`. The old code set
 * `current_bg = isPattern ? 1 : 2`, i.e. it left the segment in IMAGE mode
 * (2) with an empty `bgWallpaper` — so the Segment panel rendered an empty
 * `url()` (a broken/blank image layer) instead of reverting to "no
 * wallpaper". Removing must fall back to solid/none (0).
 *
 * Selecting a real wallpaper (non-empty value) still resolves to image (2),
 * and a pattern still resolves to pattern (1) — behaviour unchanged.
 *
 * @param {*} value - the wallpaper value (image URL / preset, or "" on remove)
 * @param {number|boolean} isPatternFlag - truthy when the wallpaper is a pattern
 * @returns {0|1|2} the resolved `current_bg`
 */
export const resolveBgWallpaperMode = (value, isPatternFlag) => {
  if (isPatternFlag) return 1;
  const hasWallpaper =
    typeof value === "string" ? value.trim().length > 0 : Boolean(value);
  return hasWallpaper ? 2 : 0;
};
